import { createApp } from 'vue';

import './utils/moonbridgeRegister';
import './utils/moonbridge';
import './utils/appFunctionListener.js';
import './utils/log.js';
import App from './App.vue';
import router from './router';
// import store from './store'
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import VConsole from 'vconsole';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import './common.less';
import './utils/bonree.js'
import './element-plus-theme.less'; // 引入自定义主题文件

import PackageJson from '../package.json'
import { setCookie } from '@/utils/cookie'

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
if (process.env.VUE_APP_NODE_BUILD_ENV != 'prod') {
  new VConsole();
  let keysString = '';
  document.addEventListener("keydown", function(event) {
    keysString += event.keyCode;
    setTimeout(()=>{keysString = ''},1000)
    if(keysString == '39393939'){ // 右右下下上上
     location.reload();
    }
  });
}else{
  let keysString = '';
  document.addEventListener("keydown", function(event) {
    keysString += event.keyCode;
    setTimeout(()=>{keysString = ''},1000)
    if(keysString == '393940403838'){ // 右右下下上上
      new VConsole();
    }
  });
}
app.use(createPinia());
app.use(router);
app.use(ElementPlus, { locale: zhCn });
app.mount('#app');
// console.log(process.env.NODE_ENV)
// console.log(process.env.VUE_APP_NODE_BUILD_ENV)
setCookie('currentVersion', PackageJson.version, {
  domain: '.xdf.cn',
  path: '/',
})
window.webApi = function () {
  console.log('webApi', arguments);
};
